import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Box } from "@mui/material";
import { ClampedTypography } from "../../../Typographies/ClampedTypography";
var RecipeAssignmentCardText;
(function (RecipeAssignmentCardText) {
    RecipeAssignmentCardText["CUSTOMIZATIONS"] = "Customizations";
})(RecipeAssignmentCardText || (RecipeAssignmentCardText = {}));
/**
 * Displays custom text with responsive styles. If no text is provided, it renders nothing.
 * It emphasizes the "Customizations" label, followed by the provided text.
 *
 * @param text - The text to display for customizations.
 */
export const SubstituteText = ({ text, customizationsHeading }) => {
    if (!text || text === "")
        return null;
    return (_jsx(Stack, Object.assign({ direction: "row", spacing: 0.25 }, { children: _jsxs(ClampedTypography, Object.assign({ variant: "caption", align: "left", lines: 2, sx: { whiteSpace: "pre-wrap" } }, { children: [_jsx(Box, Object.assign({ component: "span", fontWeight: "bold" }, { children: `${customizationsHeading}: ` || `${RecipeAssignmentCardText.CUSTOMIZATIONS}: ` })), text] })) })));
};
